import { makeObservable } from 'mobx';

import type { TConstraints } from '@feathr/rachis';

import type { ICreativeAttributes } from './creatives_base';
import { Creative, CreativeClass } from './creatives_base';

// =============================================================================
// Referral Email Creative Types
// =============================================================================

export type TReferralEmailCreative = ICreativeAttributes & {
  participant: string;
};

// =============================================================================
// Referral Email Creative Class
// =============================================================================

/**
 * ReferralEmailCreative handles referral campaign email creatives.
 * These are participant-specific email templates.
 */
export class ReferralEmailCreative extends Creative<TReferralEmailCreative> {
  public readonly className = 'ReferralEmailCreative';

  public override get constraints(): TConstraints<TReferralEmailCreative> {
    return super.constraints;
  }

  constructor(attributes: Partial<TReferralEmailCreative>) {
    super(attributes);

    makeObservable(this);
  }

  public override getDefaults(): Partial<TReferralEmailCreative> {
    return {
      ...super.getDefaults(),
      _cls: CreativeClass.ReferralEmail,
    };
  }

  public override get name(): string {
    return this.get('name', '').trim() || 'Unnamed Creative';
  }
}
